import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import ManageSvg from '../../../assets/icons/nav/manage.svg?raw';

export const ManageIcon = (props) => <CustomSVG svg={ManageSvg} preserveColors {...props} />;
